import axios from "axios";
import instance, { apiUrl } from "./api";
import useAuthStore from "../store/useAuthStore";

const userServices = {
  loginapi: (payload) => axios.post(`${apiUrl}/login`, payload),
  generateAutoLoginLink: (appId) =>
    axios.get(`${apiUrl}/applications/auto-login/${appId}`, {
      headers: {
        Authorization: `Bearer ${useAuthStore.getState().accessToken}`,
      },
    }),
  getApplications: () => instance.get("/applications"),
  checkUserExist: (data) => instance.post(`/checkuserexist`, data),   // { email }
forgetPassword: (data) => instance.post(`/forgetpassword`, data),   // { email, password, confirmpassword }

};

export default userServices;
